import { TFunction } from 'react-i18next';

const MACHINE_INFO_KEYS = [
  'active_fault_codes',
  'machine_running',
  'machine_in_transport',
  'restart_inhibited',
];

const SUBSCRIPTIONS_KEYS = [
  'basic_telematics_plan',
  'premium_telematics_plan',
  'expiring_soon',
];

export function getFilterSectionSubtitles(
  filters: string[] = [],
  t: TFunction,
) {
  const machineInfo = filters
    ?.filter(filter => MACHINE_INFO_KEYS.includes(filter))
    .map(filter => t('equipment_filters.sections.machine_info.' + filter))
    .join(', ');

  const subscriptions = filters
    ?.filter(filter => SUBSCRIPTIONS_KEYS.includes(filter))
    .map(filter =>
      t('equipment_filters.sections.kubota_now_subscription.' + filter),
    )
    .join(', ');

  return { machineInfo, subscriptions };
}
